import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

import DeleteIcon from "@material-ui/icons/Delete";
import EmailIcon from "@material-ui/icons/Email";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import NaturePeopleIcon from "@material-ui/icons/NaturePeople";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";

import firebase from "firebase/app";
import "firebase/database";

// const nodemailer = require("nodemailer");

const defaultToolbarStyles = {
  iconButton: {}
};

class CustomToolbarSelect extends React.Component {
  componentDidMount = () => {};

  handleClick = () => {
    console.log("clicked on icon!");
  };

  downloadSelected = () => {
    const { selectedRows, data } = this.props;
    var csvContent =
      "Bib Number,First Name,Last Name,Birthday,ID,Gender,Email,Phone,Nationality,Volunteer,Time Registerd,Confirmation email\n";
    var dataString = "";
    selectedRows.data.forEach((row, index) => {
      var dataRow = data[row.dataIndex];
      dataString = dataRow.join(",");
      csvContent += dataString + "\n";
      firebase
        .database()
        .ref("users/" + data[row.dataIndex][0])
        .update({ registrationEmail: true });
    });
    var download = (content, fileName, mimeType) => {
      var a = document.createElement("a");
      mimeType = mimeType || "application/octet-stream";

      if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(
          new Blob([content], {
            type: mimeType
          }),
          fileName
        );
      } else if (URL && "download" in a) {
        //html5 A[download]
        a.href = URL.createObjectURL(
          new Blob([content], {
            type: mimeType
          })
        );
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // location.href =
        //   "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
      }
    };

    download(csvContent, "newMembers.csv", "text/csv;encoding:utf-8");
  };

  emailSelected = () => {
    const { selectedRows, data } = this.props;
    var emailContent = [];
    var emails = [];
    var bibs = [];

    selectedRows.data.forEach(row => {
      emailContent.push(
        `Dear ${
          data[row.dataIndex][1]
        },%0D%0A%0D%0A You have successfully registered for the GGC5K.%0D%0AYour bib number will be the number ${
          data[row.dataIndex][0]
        }.%0D%0A You will keep this number for all meets. %0D%0A Please print your number on white paper in black ink and pin it to your t shirt for each run you attend. Please also try to memorise your number, in the event you forget to wear your bib.  Our events happen every Monday at 5.30pm so try and arrive at the Gaborone Golf Club at around 5.15pm. We do understand that life or work can get in the way and you may occasionally unavoidably arrive late.  If this happens, don’t worry, we can give you a late start.  Look at our Facebook page or website notice board for last minute information if you think there is a risk weather will affect the event happening. We will only cancel a meet if lightning poses a risk.%0D%0A%0D%0AThe golf club has showers, changing rooms and lockers (that need a padlock).  We recommend you leave all your valuables in your vehicle or at home.%0D%0A%0D%0APlease feel free to email us at ggc5kteam@gmail.com or on Facebook if you have any questions that are not answered on the website.%0D%0A%0D%0AThe GGC5K Team`
      );
      emails.push(data[row.dataIndex][6]);
      bibs.push(data[row.dataIndex][0]);
    });

    emails.forEach((email, index) => {
      window.open(
        `mailto:${email}?subject= GGC5K Registration Completed &body=${
          emailContent[index]
        }`
      );
      firebase
        .database()
        .ref("users/" + bibs[index])
        .update({ registrationEmail: true });
    });
  };

  copyEmailsToClipboard = volunteers => {
    const { data } = this.props;

    var csv = [];
    data.forEach(row => {
      if (volunteers === true) {
        if (row[9] === "Yes") {
          csv.push(row[6]);
          console.log("Yes");
        }
        console.log("no");
      } else {
        csv.push(row[6]);
        console.log("idk");
      }
    });
    var pom = document.createElement("a");
    var csvContent = csv; //here we load our csv data
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    pom.href = url;
    pom.setAttribute(
      "download",
      `${volunteers === true ? "emails" : "volunteers"}.csv`
    );
    pom.click();
  };
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Toolbar>
          <Tooltip title={"Delete Selected Rows"}>
            <IconButton
              className={classes.iconButton}
              onClick={this.handleClick}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Email Selected"}>
            <IconButton
              className={classes.iconButton}
              onClick={this.emailSelected}
            >
              <EmailIcon className={classes.deleteIcon} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Download selected in CSV file"}>
            <IconButton
              className={classes.iconButton}
              onClick={this.downloadSelected}
            >
              <MoveToInboxIcon className={classes.deleteIcon} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Copy all emails to clipboard"}>
            <IconButton
              className={classes.iconButton}
              onClick={() => this.copyEmailsToClipboard(false)}
            >
              <ContactMailIcon className={classes.deleteIcon} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Copy Volunteers Emails"}>
            <IconButton
              className={classes.iconButton}
              onClick={() => this.copyEmailsToClipboard(true)}
            >
              <NaturePeopleIcon className={classes.deleteIcon} />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </React.Fragment>
    );
  }
}

export default withStyles(defaultToolbarStyles, {
  name: "CustomToolbarSelect"
})(CustomToolbarSelect);
